import React from "react";

/**
 * Composant d'en-tête du profil avec avatar et informations de base
 */
const ProfileHeader = ({ fullName, phone }) => {
  const initial = fullName?.charAt(0)?.toUpperCase() || "U";

  return (
    <div className="flex items-center mb-6">
      <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
        {initial}
      </div>
      <div className="ml-4">
        <h2 className="text-2xl font-bold text-gray-800">
          {fullName || "Utilisateur"}
        </h2>
        <p className="text-gray-500">{phone || ""}</p>
      </div>
    </div>
  );
};

export default ProfileHeader;
